const SUP_URL = "https://supabase-interno.rc2clicks.com.br";
const SUP_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRmcXhvdnpncmZlY3Bkb2VtYW5wIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzA0MzY0MDAsImV4cCI6MjA4NjAxMjQwMH0.mz097P5rwn830f4p2a-I9hJi8acilYKBSW6r3WDs-u4";

export const LOGO_URL = "https://res.cloudinary.com/dktjldryv/image/upload/v1778106336/RC2_CLICK_horizontal_3_amnhwi.png";
const ANTHROPIC_GATEWAY = `${SUP_URL}/functions/v1/ai-gateway`;

export async function gerarCopy(client) {
  const isMedico = client.type === "Médico";
  const persona = [
    client.publico_alvo  && `Público: ${client.publico_alvo}`,
    client.dores         && `Dores: ${client.dores}`,
    client.objecoes      && `Objeções: ${client.objecoes}`,
    client.solucao       && `Solução: ${client.solucao}`,
    client.transformacao && `Transformação: ${client.transformacao}`,
  ].filter(Boolean).join("\n");

  const cfm = isMedico ? "\nIMPORTANTE — CFM: Sem promessas de cura, sem comparação com outros médicos, sem depoimentos de pacientes, sem garantia de resultado. Foque em conscientização e convite para consulta." : "";

  const prompt = `Você é especialista em copy para Meta Ads (Facebook/Instagram).${cfm}

Cliente: ${client.name} | Nicho: ${client.specialty || client.type}
${persona}

Gere 3 variações de copy para anúncio. Cada uma com Gancho, Corpo e CTA.

VARIAÇÃO 1
Gancho: [1 linha impactante]
Corpo: [2-3 linhas]
CTA: [1 linha]

VARIAÇÃO 2
Gancho: [1 linha impactante]
Corpo: [2-3 linhas]
CTA: [1 linha]

VARIAÇÃO 3
Gancho: [1 linha impactante]
Corpo: [2-3 linhas]
CTA: [1 linha]`;

  const res = await fetch(ANTHROPIC_GATEWAY, {
    method: "POST",
    headers: {
      "Authorization": `Bearer ${SUP_KEY}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      model: "claude-haiku-4-5-20251001",
      max_tokens: 1024,
      messages: [{ role: "user", content: prompt }],
    }),
  });
  if (!res.ok) throw new Error(await res.text());
  const data = await res.json();
  return data.content[0].text;
}

export async function gerarRelatorio(client, { tasks, otimizacoes, metaAds, analises, mes }) {
  const tasksDoMes   = tasks.filter((t) => t.month === mes);
  const concluidas   = tasksDoMes.filter((t) => t.status === "Concluído");
  const emAndamento  = tasksDoMes.filter((t) => t.status !== "Concluído");

  const tasksStr = concluidas.length
    ? concluidas.map((t) => {
        const done  = (t.checklist || []).filter((x) => x.done).length;
        const total = (t.checklist || []).length;
        const hist  = (t.history || []).map((h) => `    • ${h.action}${h.reason ? ` (${h.reason})` : ""}${h.notes ? ` → ${h.notes}` : ""}`).join("\n");
        return `- ${t.name} [${done}/${total} itens concluídos]${hist ? "\n" + hist : ""}`;
      }).join("\n")
    : "Nenhuma tarefa concluída registrada.";

  const andamentoStr = emAndamento.length
    ? emAndamento.map((t) => `- ${t.name} [${t.status}]`).join("\n")
    : "";

  const otimStr = otimizacoes.length
    ? otimizacoes.map((o) => `- [${o.status}] ${o.plataforma ? `(${o.plataforma}) ` : ""}${o.titulo}${o.resultado ? ` → ${o.resultado}` : ""}`).join("\n")
    : "Sem otimizações estruturadas este mês.";

  const metaStr = metaAds.filter((m) => m.mes === mes).map((m) => {
    const d = m.dados || {};
    const vals = Object.entries(d).map(([k, v]) => `${k}: ${v}`).join(", ");
    return `${m.titulo}${vals ? ": " + vals : ""}`;
  }).join("\n") || "";

  const analisesStr = analises.filter((a) => a.mes === mes)
    .map((a) => `- ${a.tipo}: ${a.titulo}`).join("\n") || "";

  const prompt = `Você é Rafael Campelo, gestor de tráfego da RC2Clicks, especializado em Meta Ads para médicos e negócios locais.

Gere um relatório mensal executivo em português do Brasil, tom profissional mas acessível, para enviar ao cliente.

CLIENTE: ${client.name}
NICHO: ${client.specialty || client.type}
PLATAFORMAS: ${client.notes || "Meta Ads"}
MÊS: ${mes}

TAREFAS CONCLUÍDAS:
${tasksStr}

${andamentoStr ? `TAREFAS EM ANDAMENTO:\n${andamentoStr}\n` : ""}OTIMIZAÇÕES E TESTES:
${otimStr}

${analisesStr ? `ANÁLISES REALIZADAS:\n${analisesStr}\n` : ""}${metaStr ? `PERFORMANCE:\n${metaStr}\n` : ""}---
Gere o relatório com estas seções exatas (use markdown com **negrito** nos títulos das seções):

**RESUMO EXECUTIVO**
[2-3 linhas do mês — o que foi feito e qual a direção]

**O QUE FOI EXECUTADO**
[Lista objetiva do que foi feito com contexto]

**TESTES E OTIMIZAÇÕES**
[O que foi testado este mês com resultado quando disponível]

**✅ VALIDADO**
[O que funcionou e deve continuar ou escalar]

**❌ DESCARTADO**
[O que não funcionou, com motivo direto]

**PRÓXIMOS PASSOS**
[3 a 5 ações prioritárias para o próximo mês]

Seja específico. Use os dados fornecidos. Se não houver dados de performance, foque nas ações e otimizações.`;

  const res = await fetch(ANTHROPIC_GATEWAY, {
    method: "POST",
    headers: {
      "Authorization": `Bearer ${SUP_KEY}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      model: "claude-haiku-4-5-20251001",
      max_tokens: 2048,
      messages: [{ role: "user", content: prompt }],
    }),
  });
  if (!res.ok) throw new Error(await res.text());
  const data = await res.json();
  return data.content[0].text;
}

export async function gerarSocialPosts(client, existingPosts) {
  const today = new Date().toISOString().split("T")[0];

  // Calcula data de início: dia seguinte ao último post pendente, ou hoje
  const pendentes = existingPosts.filter((p) => p.status === "pendente");
  const postados  = existingPosts.filter((p) => p.status === "postado");

  let startDate = today;
  if (pendentes.length > 0) {
    const lastDate = pendentes.reduce((max, p) => (p.data_prevista > max ? p.data_prevista : max), pendentes[0].data_prevista);
    const d = new Date(lastDate);
    d.setDate(d.getDate() + 1);
    startDate = d.toISOString().split("T")[0];
  }

  // Gera 15 datas consecutivas
  const dates = [];
  const cur = new Date(startDate);
  for (let i = 0; i < 15; i++) {
    dates.push(cur.toISOString().split("T")[0]);
    cur.setDate(cur.getDate() + 1);
  }
  const endDate = dates[dates.length - 1];
  const fmt = (d) => d.split("-").reverse().slice(0, 2).join("/");
  const periodo = `${fmt(startDate)}-${fmt(endDate)}`;

  const isMedico = client.type === "Médico";

  const cfm = isMedico
    ? "\n\nREGRAS CFM OBRIGATÓRIAS: nunca usar 'cura garantida' ou 'resultado 100%'. Nunca comparar com outros médicos. Sem antes/depois não autorizado. Linguagem sempre informativa — 'pode', 'em muitos casos', 'avaliação necessária'. Sempre recomendar consulta para diagnóstico."
    : "";

  const persona = [
    client.publico_alvo  && `Público-alvo: ${client.publico_alvo}`,
    client.dores         && `Dores do público: ${client.dores}`,
    client.objecoes      && `Objeções: ${client.objecoes}`,
    client.solucao       && `Solução/diferencial: ${client.solucao}`,
    client.transformacao && `Transformação prometida: ${client.transformacao}`,
  ].filter(Boolean).join("\n");

  const topicosPostados = postados.length > 0
    ? `\n\nPOSTS JÁ PUBLICADOS — analise o enredo, ângulo, narrativa e legenda completos antes de gerar. Não repita o mesmo tema, abordagem ou argumento central:\n${
        postados.map((p) => {
          const partes = [
            `[${p.data_prevista}] ${p.formato} — Tema: "${p.tema}"`,
            p.headline  && `  Headline: "${p.headline}"`,
            p.body_copy && `  Conteúdo:\n${p.body_copy.split("\n").map((l) => `    ${l}`).join("\n")}`,
            p.legenda   && `  Legenda:\n${p.legenda.split("\n").map((l) => `    ${l}`).join("\n")}`,
          ].filter(Boolean);
          return partes.join("\n");
        }).join("\n\n")
      }`
    : "";

  const datasOcupadas = pendentes.length > 0
    ? `\n\nPOSTS PENDENTES JÁ EXISTENTES — não recriar para estas datas:\n${pendentes.map((p) => `- ${p.data_prevista}: ${p.formato} — ${p.tema}`).join("\n")}`
    : "";

  const nicho = client.specialty || client.type || "marketing digital";
  const isAgencia = client.type === "Interno" || client.name?.toLowerCase().includes("rc2");

  const tom = isMedico
    ? "Tom: autoridade clínica — formal, técnico, credível. Empático mas sem perder a seriedade."
    : isAgencia
    ? "Tom: inteligência operacional — sofisticado, estratégico, direto. Transmite autoridade analítica sem ser genérico. Foco em execução e resultado real."
    : "Tom: profissional, claro, direto ao ponto. Gera identificação sem ser apelativo.";

  const prompt = `Você é especialista em social media para ${nicho}.${cfm}

CLIENTE: ${client.name}
NICHO: ${nicho}
${persona}
${tom}
${topicosPostados}
${datasOcupadas}

Gere conteúdo para o período ${startDate} a ${endDate}.
DATAS DISPONÍVEIS: ${dates.join(", ")}

REGRAS DE DISTRIBUIÇÃO:
- Stories: sequências de 3 a 5 telas por dia (identifique cada tela com tipo e conteúdo)
- Feed single: 2 por semana (posts impactantes, autoridade ou identificação)
- Carrossel: mínimo 2 no período, 6 a 7 slides cada
- Sextas e segundas: preferencialmente Feed ou Carrossel no feed
- Dias restantes: Stories

REGRAS DE COPY:
- Hook forte que para o scroll
- Stories: lógica identificação → tensão → virada → CTA
- Carrossel: cada slide com TAG (pequena, colorida) + HEADLINE (bold, grande) + BODY (menor, explicativo)
- Legenda de feed: 5 a 10 linhas, parágrafos curtos, CTA no final
- Nunca repetir tópico já publicado
- Se não há datas ocupadas, gerar post para cada data disponível

Retorne APENAS JSON válido — array puro, sem markdown, sem explicação, sem texto antes ou depois:
[{"data_prevista":"YYYY-MM-DD","formato":"Story|Feed|Carrossel","tema":"tema curto","headline":"headline impactante","body_copy":"conteúdo detalhado com estrutura de cada tela ou slide","legenda":"legenda completa pronta para publicar","hashtags":"#tag1 #tag2 #tag3"}]`;

  const res = await fetch(ANTHROPIC_GATEWAY, {
    method: "POST",
    headers: {
      "Authorization": `Bearer ${SUP_KEY}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      model: "claude-sonnet-4-6",
      max_tokens: 8000,
      messages: [{ role: "user", content: prompt }],
    }),
  });

  if (!res.ok) throw new Error(await res.text());
  const data = await res.json();
  const text = data.content[0].text.trim();

  const jsonMatch = text.match(/\[[\s\S]*\]/);
  if (!jsonMatch) throw new Error("Resposta da IA não contém JSON válido. Tente novamente.");

  const posts = JSON.parse(jsonMatch[0]);
  return posts.map((p) => ({ ...p, periodo, status: "pendente", client_id: client.id }));
}

export async function db(table, method = "GET", body = null, qs = "") {
  const res = await fetch(`${SUP_URL}/rest/v1/${table}${qs}`, {
    method,
    headers: {
      apikey: SUP_KEY,
      Authorization: `Bearer ${SUP_KEY}`,
      "Content-Type": "application/json",
      Prefer: method !== "GET" && method !== "DELETE" ? "return=representation" : "",
    },
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) throw new Error(await res.text());
  const txt = await res.text();
  return txt ? JSON.parse(txt) : null;
}
